module.exports = __webpack_public_path__ + "static/media/Resume.21372218.pdf";